<template>
  <div class="wai">
    <!-- 筛选查询区域 -->
    <div class="search-form">
      <el-form :model="query" inline>
        <el-form-item label="订单号">
          <el-input
            v-model="query.orderNo"
            placeholder="请输入订单号"
            clearable
            @keyup.enter="handleSearch"
          />
        </el-form-item>
        <el-form-item label="授权人姓名">
          <el-input
            v-model="query.name"
            placeholder="请输入姓名"
            clearable
            @keyup.enter="handleSearch"
          />
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input
            v-model="query.cardid"
            placeholder="请输入证件号"
            clearable
            @keyup.enter="handleSearch"
          />
        </el-form-item>
        <!-- 订单状态（status） -->
        <el-form-item label="订单状态">
          <el-select v-model="query.status" clearable placeholder="全部" style="width: 130px">
            <el-option label="失败" value="0" />
            <el-option label="完成" value="1" />
            <el-option label="进行中" value="2" />
            <el-option label="订单超时" value="3" />
          </el-select>
        </el-form-item>
        <!-- 审核状态（state） -->
        <el-form-item label="审核状态">
          <el-select v-model="query.state" clearable placeholder="全部" style="width: 130px">
            <el-option label="驳回" value="0" />
            <el-option label="待审" value="1" />
            <el-option label="审核成功" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="query.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            :shortcuts="dateShortcuts"
            style="width: 260px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" :disabled="selectedRows.length === 0" @click="batchExport">
            批量导出结果
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格主体 -->
    <div class="zhu">
      <el-table
        :data="tableList"
        border
        stripe
        class="biao"
        ref="tableRef"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column label="订单号" prop="orderNo" align="center" min-width="240" />
        <el-table-column label="授权人姓名" prop="name" align="center" width="120" />
        <el-table-column label="授权人证件号" align="center" width="200">
          <template #default="scope">
            {{ desensitizeIdCard(scope.row.cardid) }}
          </template>
        </el-table-column>
        <el-table-column label="核验类型" align="center" width="130">
          <template #default="scope">
            {{ labTypeMap[scope.row.lab] || scope.row.lab || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="180">
          <template #default="scope">
            {{ formatIsoTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="请求时间" align="center" width="180">
          <template #default="scope">
            {{ formatIsoTime(scope.row.req_time) }}
          </template>
        </el-table-column>
        <el-table-column label="结果数量" prop="resultSize" align="center" width="100" />
        <!-- 审核状态 state -->
        <el-table-column label="审核状态" align="center" width="120">
          <template #default="scope">
            <el-tag :type="getStateTagType(scope.row.state)">
              {{ stateTextMap[scope.row.state] || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- 订单状态 status -->
        <el-table-column label="订单状态" align="center" width="120">
          <template #default="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">
              {{ statusTextMap[scope.row.status] || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template #default="scope">
            <el-button type="primary" text @click="viewResult(scope.row)">
              查看结果
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="page">
      <div style="margin-right:16px;color:#666" v-if="selectedRows.length > 0">
        已选中 <span style="color:#2B5BFF;font-weight:bold">{{ selectedRows.length }}</span> 条
      </div>
      <el-pagination
        v-model:current-page="page.pageNum"
        v-model:page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSearch"
        @current-change="handleSearch"
      />
    </div>

    <!-- ========== 订单详情弹窗 ========== -->
    <el-dialog
      v-model="detailDialogVisible"
      title="订单详情"
      width="680px"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-descriptions border :column="2" label-width="120px">
        <el-descriptions-item label="订单号">
          {{ currentRow.orderNo || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="授权人姓名">
          {{ currentRow.name || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="授权人证件号">
          {{ desensitizeIdCard(currentRow.cardid) }}
        </el-descriptions-item>
        <el-descriptions-item label="核验类型">
          {{ labTypeMap[currentRow.lab] || currentRow.lab || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{ formatIsoTime(currentRow.create_time) }}
        </el-descriptions-item>
        <el-descriptions-item label="请求时间">
          {{ formatIsoTime(currentRow.req_time) }}
        </el-descriptions-item>
        <el-descriptions-item label="结果数量">
          {{ currentRow.resultSize ?? 0 }}
        </el-descriptions-item>
        <el-descriptions-item label="状态提示">
          {{ currentRow.state_tips || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag :type="getStateTagType(currentRow.state)">
            {{ stateTextMap[currentRow.state] || '-' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="getStatusTagType(currentRow.status)">
            {{ statusTextMap[currentRow.status] || '-' }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>

      <template #footer>
        <div class="dialog-footer">
          <el-button
            type="success"
            :loading="downloadLoading"
            :disabled="currentRow.status !== 1"
            @click="handleDownloadFile"
          >
            下载核验结果文件
          </el-button>
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import { ref, reactive, onMounted } from 'vue'
import { getIamOrderList, exportBdcOrder } from '@/api/api'

const tableRef = ref(null)
const selectedRows = ref([])

// 详情弹窗
const detailDialogVisible = ref(false)
const currentRow = ref({})
const downloadLoading = ref(false)

// ==========状态映射定义==========
/**
 * status 订单状态
 * 0 失败，1 完成，2 进行中，3 订单超时
 */
const statusTextMap = {
  0: '失败',
  1: '完成',
  2: '进行中',
  3: '订单超时'
}
const getStatusTagType = (status) => {
  if (status === 0) return 'danger'
  if (status === 1) return 'success'
  if (status === 2) return 'warning'
  if (status === 3) return 'info'
  return ''
}

/**
 * state 审核状态
 * 0 驳回，1 待审，2 审核成功
 */
const stateTextMap = {
  0: '驳回',
  1: '待审',
  2: '审核成功'
}
const getStateTagType = (state) => {
  if (state === 0) return 'danger'
  if (state === 1) return 'warning'
  if (state === 2) return 'success'
  return ''
}

// 核验类型lab映射
const labTypeMap = {
  realestate: '不动产核验'
}

// 查询条件
const query = reactive({
  name: '',
  cardid: '',
  orderNo: '',
  status: '',
  state: '',
  dateRange: []
})

// 分页
const page = reactive({
  pageNum: 1,
  pageSize: 10,
  total: 0
})

const tableList = ref([])

// 日期快捷选项
const dateShortcuts = [
  {
    text: '今日',
    value: () => {
      const now = new Date()
      return [new Date(now.setHours(0, 0, 0, 0)), new Date()]
    }
  },
  {
    text: '本周',
    value: () => {
      const now = new Date()
      const day = now.getDay() || 7
      const start = new Date(now.getTime() - (day - 1) * 24 * 3600 * 1000)
      start.setHours(0, 0, 0, 0)
      return [start, new Date()]
    }
  },
  {
    text: '本月',
    value: () => {
      const now = new Date()
      const start = new Date(now.getFullYear(), now.getMonth(), 1)
      start.setHours(0, 0, 0, 0)
      return [start, new Date()]
    }
  }
]

// ISO时间格式化 2026-08-10T11:01:27 → 2026-08-10 11:01:27
const formatIsoTime = (timeStr) => {
  if (!timeStr) return '-'
  return timeStr.replace('T', ' ')
}

// 身份证脱敏
const desensitizeIdCard = (id) => {
  if (!id) return '-'
  const str = String(id)
  if (str.length < 10) return str
  return str.slice(0, 6) + '********' + str.slice(-4)
}

const handleSelectionChange = (val) => {
  selectedRows.value = val
}

// 批量导出
const batchExport = async () => {
  if (!selectedRows.value.length) {
    ElMessage.warning('请先勾选需要导出的数据')
    return
  }
  const orderNos = selectedRows.value.map(row => row.orderNo)
  ElMessage.success(`选中${orderNos.length}条，开始导出`)
}

// 请求列表核心方法
const getBtcIamOrderList = async () => {
  const params = {}
  if (query.name) params.name = query.name
  if (query.cardid) params.cardid = query.cardid
  if (query.orderNo) params.orderNo = query.orderNo
  if (query.status !== '') params.status = query.status
  if (query.state !== '') params.state = query.state
  params.page = page.pageNum
  params.pageSize = page.pageSize

  const res = await getIamOrderList(params)
  console.log('订单列表返回：', res)
  if (res.code === 200) {
    tableList.value = res.data.list
    page.total = res.data.total
  } else {
    ElMessage.error(res.message || '获取列表失败')
    tableList.value = []
    page.total = 0
  }
}

// 查询入口
const handleSearch = () => {
  selectedRows.value = []
  tableRef.value?.clearSelection()
  getBtcIamOrderList()
}

// 重置
const resetQuery = () => {
  query.name = ''
  query.cardid = ''
  query.orderNo = ''
  query.status = ''
  query.state = ''
  query.dateRange = []
  page.pageNum = 1
  selectedRows.value = []
  tableRef.value?.clearSelection()
  getBtcIamOrderList()
}

// 查看详情弹窗
const viewResult = (row) => {
  currentRow.value = { ...row }
  detailDialogVisible.value = true
}

/**
 * 弹窗下载xlsx文件流，增加json错误捕获
 */
const handleDownloadFile = async () => {
  if (!currentRow.value.orderNo) return
  downloadLoading.value = true
  try {
    const res = await exportBdcOrder({ orderNo: currentRow.value.orderNo })
    console.log('下载接口返回：', res)

    let blobData = res
    // axios完整响应对象，取内部blob二进制
    if (res?.data instanceof Blob) {
      blobData = res.data
    }

    // 判断后端返回的是json报错，不是文件流
    if (blobData.type === 'application/json') {
      const text = await blobData.text()
      const errJson = JSON.parse(text)
      ElMessage.error(errJson.message || '下载失败')
      return
    }

    const blob = new Blob([blobData], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })

    let filename = `${currentRow.value.orderNo}_核验结果.xlsx`
    const headers = res?.headers || {}
    const disposition = headers['content-disposition']
    if (disposition) {
      const match = disposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/i)
      if (match) {
        filename = decodeURIComponent(match[1].replace(/["']/g, ''))
      }
    }

    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
    ElMessage.success('文件下载完成')
  } catch (err) {
    console.error('下载异常：', err)
    ElMessage.error('文件下载失败，请重试')
  } finally {
    downloadLoading.value = false
  }
}

onMounted(() => {
  getBtcIamOrderList()
})
</script>

<style lang="scss" scoped>
.wai {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;

  .search-form {
    width: 100%;
    padding: 12px 0;
  }

  .zhu {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }

  .page {
    width: 100%;
    height: 48px;
    display: flex;
    padding: 10px 0;
    justify-content: flex-end;
    align-items: center;
  }
  .dialog-footer{
    display:flex;
    gap:10px;
    justify-content: flex-end;
  }
}
</style>